import { render } from "./digitalhuman.vue?vue&type=template&id=40aa2974&scoped=true"
import script from "./digitalhuman.vue?vue&type=script&lang=js"
export * from "./digitalhuman.vue?vue&type=script&lang=js"

import "./digitalhuman.vue?vue&type=style&index=0&id=40aa2974&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40aa2974"]])

export default __exports__